import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import { AddImageInfo } from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function ImageAdd({ imageAdd, setImageAdd }) {
  const [mainPhoto, setMainPhoto] = useState("");
  const [photoFile, setPhotoFile] = useState();
  const [name, setName] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setPhotoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const saveNewImageInfo = () => {
    dispatch(AddImageInfo({ name, photoFile }));
    setMainPhoto("");
    setName("");
    toast.info("Adding Image...", { autoClose: false });
    setImageAdd(false);
  };
  return (
    imageAdd && (
      <div className="images-add-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setImageAdd(false)}
        ></div>
        <div className="container ">
          <div className="title">اضافه صوره جديده</div>
          <label
            htmlFor="add-image"
            className={mainPhoto ? `image` : `image none`}
          >
            <img src={mainPhoto ? `${mainPhoto}` : `/images/add.png`} alt="" />
          </label>
          <input
            type="file"
            onChange={handleFileChange}
            name=""
            accept="image/*"
            id="add-image"
            style={{ display: "none" }}
          />
          <div className="text">
            <input
              type="text"
              placeholder="Details Of Image"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewImageInfo()}>
            اضافه
          </div>
        </div>
      </div>
    )
  );
}
